var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ticket-registration-view" },
    [
      _vm.isRequesting ? [_c("spinner")] : _vm._e(),
      _vm._v(" "),
      _vm.isRequestingDownloadLinks
        ? [
            _vm.ticketDownloadResponse &&
            _vm.ticketDownloadResponse.tickets.length
              ? [
                  _vm._l(_vm.ticketDownloadResponse.tickets, function (ticket) {
                    return [
                      _c(
                        "div",
                        { staticClass: "ticket-download-item" },
                        [
                          _c("h3", [
                            _c("strong", [_vm._v(_vm._s(ticket.productTitle))]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$t("titles.event")) + ":"),
                            ]),
                            _vm._v(" " + _vm._s(ticket.eventTitle)),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$t("titles.client")) + ":"),
                            ]),
                            _vm._v(" " + _vm._s(ticket.clientTitle)),
                          ]),
                          _vm._v(" "),
                          ticket.name
                            ? [
                                _c("p", [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.$t("titles.name")) + ":"),
                                  ]),
                                  _vm._v(" " + _vm._s(ticket.name)),
                                ]),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          ticket.date
                            ? [
                                _c("p", [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.$t("titles.date")) + ":"),
                                  ]),
                                  _vm._v(" " + _vm._s(ticket.date)),
                                ]),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c("p", [
                            _c("strong", [_vm._v("VVS:")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  ticket.pubTransIncluded
                                    ? _vm.$t("global.forms.yes")
                                    : _vm.$t("global.forms.no")
                                )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "button",
                              attrs: { target: "_blank", href: ticket.linkPdf },
                            },
                            [_vm._v("PDF Download")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "button",
                              attrs: {
                                target: "_blank",
                                href: ticket.linkWallet,
                              },
                            },
                            [_vm._v("Wallet Download")]
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("hr"),
                    ]
                  }),
                ]
              : [
                  _c("p", { staticClass: "ticket-generation" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("checkoutSuccess.ticketGeneration", {
                          progress: _vm.downloadLinkProgress,
                        })
                      )
                    ),
                  ]),
                ],
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.ticketClaimSuccess && !_vm.shouldGenerateDownloadLinks
        ? [_c("h3", [_vm._v(_vm._s(_vm.$t("registerTickets.claimSuccess")))])]
        : _vm._e(),
      _vm._v(" "),
      !_vm.isRequesting && !_vm.ticketClaimSuccess
        ? [
            !_vm.isAuthenticated && _vm.mustOrderWithLogin
              ? [
                  _c("div", { staticClass: "alert alert-info" }, [
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.$t("registerTickets.accountRequiredHint"))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "button",
                      attrs: { href: _vm.loginPageUrlWithReturnUrl },
                    },
                    [_vm._v(_vm._s(_vm.$t("global.links.toLogin")))]
                  ),
                ]
              : _vm.isAuthenticated && _vm.mustOrderAsGuest
              ? [
                  _c("div", { staticClass: "alert alert-info" }, [
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.$t("registerTickets.guestRequiredHint"))
                      ),
                    ]),
                  ]),
                ]
              : !_vm.hasRegistrationCodes
              ? [
                  _c("div", { staticClass: "alert alert-info" }, [
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.$t("registerTickets.noRegistrationCode"))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.cancelRegistration.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("global.links.toTicketShop")) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              : _vm.hasRequiredData && _vm.activeProduct
              ? [
                  _c(
                    "form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.processRegistration.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("h3", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("registerTickets.headline", [
                                _vm.$tm(
                                  _vm.activeProduct,
                                  "descriptionWebShop"
                                ),
                                _vm.$tm(
                                  _vm.getEventById(_vm.activeProduct.eventId),
                                  "descriptionExternal"
                                ),
                              ])
                            ) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      [
                        _c(
                          "div",
                          { staticClass: "registration__invitationInfo" },
                          [
                            _c(
                              "div",
                              { staticClass: "registration__invitationText" },
                              [
                                _c(
                                  "h3",
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "registerTickets.invitationHeadline"
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                    _vm.exhibitorNames.length > 0
                                      ? [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t("registerTickets.from")
                                              )
                                          ),
                                          _c(
                                            "strong",
                                            {
                                              staticClass:
                                                "registration__invitationCompany",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.exhibitorNames[0])
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _vm.hasExhibitorAdvertising &&
                                _vm.hasExhibitorLogo
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "registration__invitationLogoMobile",
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: _vm.exhibitorLogoUrl,
                                              loading: "lazy",
                                              alt:
                                                _vm.$t(
                                                  "registerTickets.inviterLogoAlt1"
                                                ) +
                                                " " +
                                                (_vm.exhibitorNames[0] ||
                                                  _vm.$t(
                                                    "registerTickets.inviterLogoAlt2"
                                                  )),
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("registerTickets.invitationText")
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm.hasExhibitorAdvertising && _vm.hasExhibitorLogo
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "registration__invitationLogoDesktop",
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: _vm.exhibitorLogoUrl,
                                          loading: "lazy",
                                          alt:
                                            _vm.$t(
                                              "registerTickets.inviterLogoAlt1"
                                            ) +
                                            " " +
                                            (_vm.exhibitorNames[0] ||
                                              _vm.$t(
                                                "registerTickets.inviterLogoAlt2"
                                              )),
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ],
                      _vm._v(" "),
                      _c("h4", [
                        _vm._v(
                          _vm._s(_vm.$t("registerTickets.code")) +
                            _vm._s(_vm.registrationCodes[0])
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkout-view" }, [
                        _c("div", { staticClass: "checkout__wizard" }, [
                          _c(
                            "div",
                            { staticClass: "checkout-form__container" },
                            [
                              _vm.slots.length > 0
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "checkout-form__group checkout-form__group--paddingMobile",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "checkout__slot-selection",
                                          },
                                          [
                                            _c(
                                              "Modal",
                                              { ref: "slotSelectionModal" },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "trigger" },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "registerTickets.checkout.selectSlot"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "template",
                                                  { slot: "content" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "ticketModal",
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          { staticClass: "h2" },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "registerTickets.checkout.selectSlot"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          _vm.products,
                                                          function (
                                                            product,
                                                            pIdx
                                                          ) {
                                                            return [
                                                              product.slots
                                                                .length > 0 &&
                                                              product.distributionChannelId ===
                                                                2
                                                                ? [
                                                                    _c("h5", [
                                                                      _vm._v(
                                                                        "\n                                " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "registerTickets.headline",
                                                                              [
                                                                                _vm.$tm(
                                                                                  product,
                                                                                  "descriptionWebShop"
                                                                                ),
                                                                                _vm.$tm(
                                                                                  _vm.getEventById(
                                                                                    product.eventId
                                                                                  ),
                                                                                  "descriptionExternal"
                                                                                ),
                                                                              ]
                                                                            )
                                                                          ) +
                                                                          "\n                              "
                                                                      ),
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _vm._l(
                                                                      _vm.getSlotsByIds(
                                                                        product.slots
                                                                      ),
                                                                      function (
                                                                        slot
                                                                      ) {
                                                                        return [
                                                                          _c(
                                                                            "label",
                                                                            {
                                                                              key:
                                                                                product.id +
                                                                                "-" +
                                                                                slot.id,
                                                                              staticClass:
                                                                                "ticketModal__itemSlot clr",
                                                                              attrs:
                                                                                {
                                                                                  for:
                                                                                    product.id +
                                                                                    "-" +
                                                                                    slot.id,
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.selectSlot(
                                                                                      product,
                                                                                      slot
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "input",
                                                                                {
                                                                                  directives:
                                                                                    [
                                                                                      {
                                                                                        name: "model",
                                                                                        rawName:
                                                                                          "v-model",
                                                                                        value:
                                                                                          _vm
                                                                                            .selectedSlots[
                                                                                            product
                                                                                              .id
                                                                                          ],
                                                                                        expression:
                                                                                          "selectedSlots[product.id]",
                                                                                      },
                                                                                    ],
                                                                                  staticClass:
                                                                                    "ticketModal__itemSlotRadio",
                                                                                  attrs:
                                                                                    {
                                                                                      type: "radio",
                                                                                      id:
                                                                                        product.id +
                                                                                        "-" +
                                                                                        slot.id,
                                                                                      name:
                                                                                        "slot-for-" +
                                                                                        product.id,
                                                                                    },
                                                                                  domProps:
                                                                                    {
                                                                                      value:
                                                                                        slot.id,
                                                                                      checked:
                                                                                        _vm._q(
                                                                                          _vm
                                                                                            .selectedSlots[
                                                                                            product
                                                                                              .id
                                                                                          ],
                                                                                          slot.id
                                                                                        ),
                                                                                    },
                                                                                  on: {
                                                                                    change:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.$set(
                                                                                          _vm.selectedSlots,
                                                                                          product.id,
                                                                                          slot.id
                                                                                        )
                                                                                      },
                                                                                  },
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "ticketModal__itemSlotCheck",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "Check"
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "ticketModal__itemSlotHeadline",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                              " +
                                                                                      _vm._s(
                                                                                        _vm._f(
                                                                                          "formatTimeString"
                                                                                        )(
                                                                                          slot.printStart,
                                                                                          _vm.userLanguage
                                                                                        )
                                                                                      ) +
                                                                                      "\n                              -\n                              " +
                                                                                      _vm._s(
                                                                                        _vm._f(
                                                                                          "formatTimeString"
                                                                                        )(
                                                                                          slot.printEnd,
                                                                                          _vm.userLanguage
                                                                                        )
                                                                                      ) +
                                                                                      "\n                              Uhr\n                            "
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "ticketModal__itemSlotText",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "\n                              " +
                                                                                      _vm._s(
                                                                                        _vm._f(
                                                                                          "formatDateString"
                                                                                        )(
                                                                                          slot.printStart,
                                                                                          _vm.userLanguage
                                                                                        )
                                                                                      ) +
                                                                                      "\n                              "
                                                                                  ),
                                                                                  new Date(
                                                                                    slot.printStart
                                                                                  ).getDate() !==
                                                                                  new Date(
                                                                                    slot.printEnd
                                                                                  ).getDate()
                                                                                    ? [
                                                                                        _vm._v(
                                                                                          "\n                                -  " +
                                                                                            _vm._s(
                                                                                              _vm._f(
                                                                                                "formatDateString"
                                                                                              )(
                                                                                                slot.printEnd,
                                                                                                _vm.userLanguage
                                                                                              )
                                                                                            ) +
                                                                                            "\n                              "
                                                                                        ),
                                                                                      ]
                                                                                    : _vm._e(),
                                                                                ],
                                                                                2
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      }
                                                                    ),
                                                                  ]
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              pIdx <
                                                              _vm.products
                                                                .length -
                                                                1
                                                                ? [_c("hr")]
                                                                : _vm._e(),
                                                            ]
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _vm.hasSelectedSlots
                                              ? [
                                                  _c("h4", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "registerTickets.checkout.selectedSlots"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.selectedSlots,
                                                    function (
                                                      slotId,
                                                      productId
                                                    ) {
                                                      return [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$tm(
                                                                _vm.getProductById(
                                                                  productId
                                                                ),
                                                                "descriptionWebShop"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          ":\n                        "
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "ticketModal__itemSlotHeadline",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatTimeString"
                                                                  )(
                                                                    _vm.getSlotById(
                                                                      slotId
                                                                    )
                                                                      .printStart,
                                                                    _vm.userLanguage
                                                                  )
                                                                ) +
                                                                "\n                      -\n                      " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatTimeString"
                                                                  )(
                                                                    _vm.getSlotById(
                                                                      slotId
                                                                    ).printEnd,
                                                                    _vm.userLanguage
                                                                  )
                                                                ) +
                                                                "\n                      Uhr\n                    "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "ticketModal__itemSlotText",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatDateString"
                                                                  )(
                                                                    _vm.getSlotById(
                                                                      slotId
                                                                    )
                                                                      .printStart,
                                                                    _vm.userLanguage
                                                                  )
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                            new Date(
                                                              _vm.getSlotById(
                                                                slotId
                                                              ).printStart
                                                            ).getDate() !==
                                                            new Date(
                                                              _vm.getSlotById(
                                                                slotId
                                                              ).printEnd
                                                            ).getDate()
                                                              ? [
                                                                  _vm._v(
                                                                    "\n                        -  " +
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "formatDateString"
                                                                        )(
                                                                          _vm.getSlotById(
                                                                            slotId
                                                                          )
                                                                            .printEnd,
                                                                          _vm.userLanguage
                                                                        )
                                                                      ) +
                                                                      "\n                      "
                                                                  ),
                                                                ]
                                                              : _vm._e(),
                                                          ],
                                                          2
                                                        ),
                                                      ]
                                                    }
                                                  ),
                                                ]
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._m(0),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.enablePersonalization
                                ? [
                                    _c("customer-form", {
                                      key: "personalization",
                                      ref: "personalizationForm",
                                      attrs: {
                                        context: "personalization",
                                        "customer-data-d-t-o":
                                          _vm.personalizationDTO,
                                        "inventory-url": _vm.inventoryUrl,
                                        "show-errors": _vm.showErrors,
                                        "required-fields":
                                          _vm.requiredPersonalizationFields,
                                        "disabled-fields":
                                          _vm.disabledPersonalizationFields,
                                      },
                                      on: {
                                        update: _vm.updatePersonalizationDTO,
                                        isZipValid: _vm.setIsZipValid,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "checkout-form__group" },
                                      [
                                        _c("p", [
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "global.forms.requiredInfo"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                  ]
                                : [
                                    _c(
                                      "div",
                                      { staticClass: "checkout-form__group" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "checkout-form__field",
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                attrs: { for: "single-email" },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "global.forms.mail"
                                                      )
                                                    ) +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "global.forms.required"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.initialBuyerData
                                              ? [
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.personalizationDTO
                                                          .email
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              : [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName:
                                                          "v-model.trim.lazy",
                                                        value:
                                                          _vm.personalizationDTO
                                                            .email,
                                                        expression:
                                                          "personalizationDTO.email",
                                                        modifiers: {
                                                          trim: true,
                                                          lazy: true,
                                                        },
                                                      },
                                                    ],
                                                    attrs: {
                                                      id: "single-email",
                                                      name: "email",
                                                      type: "email",
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.personalizationDTO
                                                          .email,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        _vm.$set(
                                                          _vm.personalizationDTO,
                                                          "email",
                                                          $event.target.value.trim()
                                                        )
                                                      },
                                                      blur: function ($event) {
                                                        return _vm.$forceUpdate()
                                                      },
                                                    },
                                                  }),
                                                ],
                                          ],
                                          2
                                        ),
                                      ]
                                    ),
                                  ],
                              _vm._v(" "),
                              _vm.anyProductHasPubTransIncluded
                                ? [
                                    _vm._m(1),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "publicTransport__header",
                                      },
                                      [
                                        _c("Vvs"),
                                        _vm._v(" "),
                                        _c("p", { staticClass: "h2" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "registerTickets.checkout.transportation"
                                              )
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.showErrors &&
                                    !_vm.isPublicTransportValid
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "checkout-form__error",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "global.errorMessages.unfinishedForm"
                                                  )
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("registration-public-transport-modal", {
                                      ref: "pubTransComponent",
                                      attrs: {
                                        "modal-trigger-text": _vm.$t(
                                          "checkout.personalisation.publicTransport.select"
                                        ),
                                        "inventory-url": _vm.inventoryUrl,
                                        "initial-pub-trans-configs":
                                          _vm.personalizationDTO
                                            .publicTransportConfigs,
                                        "submit-cb": _vm.submitPublicTransport,
                                        "slot-id":
                                          _vm.slots && _vm.slots.length > 0
                                            ? _vm.slots[0].id
                                            : null,
                                        product: _vm.products[0],
                                      },
                                    }),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasEvents &&
                              _vm.hasSurveys &&
                              _vm.isBesucher &&
                              !_vm.hideSurvey
                                ? [
                                    _vm._m(2),
                                    _vm._v(" "),
                                    _c("h3", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "checkout.personalisation.visitorSurvey.headline"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "checkout-form__group" },
                                      [
                                        _vm._l(_vm.events, function (event) {
                                          return [
                                            _vm.hasSurvey(event)
                                              ? [
                                                  _c(
                                                    "visitor-survey-component",
                                                    {
                                                      key: event.id,
                                                      ref: "survey" + event.id,
                                                      refInFor: true,
                                                      attrs: {
                                                        initial:
                                                          _vm.getInitialSurveyData(
                                                            event
                                                          ),
                                                        event: event,
                                                        "inventory-url":
                                                          _vm.inventoryUrl,
                                                        "visitor-survey":
                                                          event.visitorSurvey,
                                                        "order-items": [
                                                          _vm.activeProduct,
                                                        ],
                                                      },
                                                      on: {
                                                        hideSurvey: function (
                                                          $event
                                                        ) {
                                                          _vm.hideSurvey = true
                                                        },
                                                        update: function (
                                                          $event
                                                        ) {
                                                          return _vm.updateSurveyData(
                                                            $event,
                                                            event
                                                          )
                                                        },
                                                      },
                                                    }
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "checkout-form__group",
                                                    },
                                                    [_c("hr")]
                                                  ),
                                                ]
                                              : _vm._e(),
                                          ]
                                        }),
                                      ],
                                      2
                                    ),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._m(3),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "checkout-form__group privacyStatement",
                                },
                                [
                                  _vm.clientsWithConsentExist
                                    ? [
                                        _vm._l(
                                          _vm.clientsWithConsent,
                                          function (client, idx) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  key: client.id,
                                                  staticClass:
                                                    "client-agb-privacy",
                                                },
                                                [
                                                  _c("h4", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "privacy.headlineClient",
                                                          {
                                                            eventsTitle:
                                                              _vm.eventConsentString(
                                                                client.id
                                                              ),
                                                          }
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _vm.additionalNotices[
                                                    "" + client.id
                                                  ]
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "checkout__additional-notices-container",
                                                          },
                                                          [
                                                            _c("div", {
                                                              staticClass:
                                                                "additional-notice",
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    _vm.additionalNoticeHtmlFor(
                                                                      client.id
                                                                    )
                                                                  ),
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.privacyStatements[
                                                    "" + client.id
                                                  ]
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__group form__group--checkbox",
                                                            class: {
                                                              "form__field--error":
                                                                _vm.showErrors &&
                                                                !_vm.acceptedClientsPrivacyStatements,
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form__label",
                                                                attrs: {
                                                                  for:
                                                                    "privacy-" +
                                                                    client.id,
                                                                },
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .personalizationDTO
                                                                          .privacyStatements,
                                                                      expression:
                                                                        "personalizationDTO.privacyStatements",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    id:
                                                                      "privacy-" +
                                                                      client.id,
                                                                    name: "privacy",
                                                                    required:
                                                                      "",
                                                                    type: "checkbox",
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm
                                                                        .privacyStatements[
                                                                        "" +
                                                                          client.id
                                                                      ].id,
                                                                    checked:
                                                                      Array.isArray(
                                                                        _vm
                                                                          .personalizationDTO
                                                                          .privacyStatements
                                                                      )
                                                                        ? _vm._i(
                                                                            _vm
                                                                              .personalizationDTO
                                                                              .privacyStatements,
                                                                            _vm
                                                                              .privacyStatements[
                                                                              "" +
                                                                                client.id
                                                                            ].id
                                                                          ) > -1
                                                                        : _vm
                                                                            .personalizationDTO
                                                                            .privacyStatements,
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        var $$a =
                                                                            _vm
                                                                              .personalizationDTO
                                                                              .privacyStatements,
                                                                          $$el =
                                                                            $event.target,
                                                                          $$c =
                                                                            $$el.checked
                                                                              ? true
                                                                              : false
                                                                        if (
                                                                          Array.isArray(
                                                                            $$a
                                                                          )
                                                                        ) {
                                                                          var $$v =
                                                                              _vm
                                                                                .privacyStatements[
                                                                                "" +
                                                                                  client.id
                                                                              ]
                                                                                .id,
                                                                            $$i =
                                                                              _vm._i(
                                                                                $$a,
                                                                                $$v
                                                                              )
                                                                          if (
                                                                            $$el.checked
                                                                          ) {
                                                                            $$i <
                                                                              0 &&
                                                                              _vm.$set(
                                                                                _vm.personalizationDTO,
                                                                                "privacyStatements",
                                                                                $$a.concat(
                                                                                  [
                                                                                    $$v,
                                                                                  ]
                                                                                )
                                                                              )
                                                                          } else {
                                                                            $$i >
                                                                              -1 &&
                                                                              _vm.$set(
                                                                                _vm.personalizationDTO,
                                                                                "privacyStatements",
                                                                                $$a
                                                                                  .slice(
                                                                                    0,
                                                                                    $$i
                                                                                  )
                                                                                  .concat(
                                                                                    $$a.slice(
                                                                                      $$i +
                                                                                        1
                                                                                    )
                                                                                  )
                                                                              )
                                                                          }
                                                                        } else {
                                                                          _vm.$set(
                                                                            _vm.personalizationDTO,
                                                                            "privacyStatements",
                                                                            $$c
                                                                          )
                                                                        }
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "checkbox-label icon icon-check",
                                                                }),
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "privacy.client.privacyStatement1"
                                                                      )
                                                                    ) +
                                                                    "\n                            "
                                                                ),
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "inline-link",
                                                                    attrs: {
                                                                      href: "#",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          $event.stopPropagation()
                                                                          $event.preventDefault()
                                                                          return _vm.openPrivacyModal(
                                                                            client
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "privacy.client.privacyStatement2"
                                                                          )
                                                                        )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "privacy.client.privacyStatement3"
                                                                      )
                                                                    ) +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "global.forms.required"
                                                                      )
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    : [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__group form__group--checkbox",
                                                            class: {
                                                              "form__field--error":
                                                                _vm.showErrors &&
                                                                !_vm
                                                                  .personalizationDTO
                                                                  .fallbackPrivacyChecked,
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form__label",
                                                                attrs: {
                                                                  for: "privacy-fallback",
                                                                },
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .personalizationDTO
                                                                          .fallbackPrivacyChecked,
                                                                      expression:
                                                                        "personalizationDTO.fallbackPrivacyChecked",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    id: "privacy-fallback",
                                                                    name: "privacy",
                                                                    required:
                                                                      "",
                                                                    type: "checkbox",
                                                                  },
                                                                  domProps: {
                                                                    checked:
                                                                      Array.isArray(
                                                                        _vm
                                                                          .personalizationDTO
                                                                          .fallbackPrivacyChecked
                                                                      )
                                                                        ? _vm._i(
                                                                            _vm
                                                                              .personalizationDTO
                                                                              .fallbackPrivacyChecked,
                                                                            null
                                                                          ) > -1
                                                                        : _vm
                                                                            .personalizationDTO
                                                                            .fallbackPrivacyChecked,
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        var $$a =
                                                                            _vm
                                                                              .personalizationDTO
                                                                              .fallbackPrivacyChecked,
                                                                          $$el =
                                                                            $event.target,
                                                                          $$c =
                                                                            $$el.checked
                                                                              ? true
                                                                              : false
                                                                        if (
                                                                          Array.isArray(
                                                                            $$a
                                                                          )
                                                                        ) {
                                                                          var $$v =
                                                                              null,
                                                                            $$i =
                                                                              _vm._i(
                                                                                $$a,
                                                                                $$v
                                                                              )
                                                                          if (
                                                                            $$el.checked
                                                                          ) {
                                                                            $$i <
                                                                              0 &&
                                                                              _vm.$set(
                                                                                _vm.personalizationDTO,
                                                                                "fallbackPrivacyChecked",
                                                                                $$a.concat(
                                                                                  [
                                                                                    $$v,
                                                                                  ]
                                                                                )
                                                                              )
                                                                          } else {
                                                                            $$i >
                                                                              -1 &&
                                                                              _vm.$set(
                                                                                _vm.personalizationDTO,
                                                                                "fallbackPrivacyChecked",
                                                                                $$a
                                                                                  .slice(
                                                                                    0,
                                                                                    $$i
                                                                                  )
                                                                                  .concat(
                                                                                    $$a.slice(
                                                                                      $$i +
                                                                                        1
                                                                                    )
                                                                                  )
                                                                              )
                                                                          }
                                                                        } else {
                                                                          _vm.$set(
                                                                            _vm.personalizationDTO,
                                                                            "fallbackPrivacyChecked",
                                                                            $$c
                                                                          )
                                                                        }
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "checkbox-label icon icon-check",
                                                                }),
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "privacy.client.privacyStatement1"
                                                                      )
                                                                    ) +
                                                                    "\n                            "
                                                                ),
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "inline-link",
                                                                    attrs: {
                                                                      target:
                                                                        "_blank",
                                                                      href: "https://www.messe-stuttgart.de/datenschutzerklaerung/",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "privacy.client.privacyStatement2"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "privacy.client.privacyStatement3"
                                                                      )
                                                                    ) +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "global.forms.required"
                                                                      )
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                  _vm._v(" "),
                                                  _vm.agb["" + client.id]
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__group form__group--checkbox",
                                                            class: {
                                                              "form__field--error":
                                                                _vm.showErrors &&
                                                                !_vm.acceptedClientsAGB,
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form__label",
                                                                attrs: {
                                                                  for:
                                                                    "agb-" +
                                                                    client.id,
                                                                },
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .personalizationDTO
                                                                          .termsAndConditions,
                                                                      expression:
                                                                        "personalizationDTO.termsAndConditions",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    id:
                                                                      "agb-" +
                                                                      client.id,
                                                                    name: "agb",
                                                                    required:
                                                                      "",
                                                                    type: "checkbox",
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm.agb[
                                                                        "" +
                                                                          client.id
                                                                      ].id,
                                                                    checked:
                                                                      Array.isArray(
                                                                        _vm
                                                                          .personalizationDTO
                                                                          .termsAndConditions
                                                                      )
                                                                        ? _vm._i(
                                                                            _vm
                                                                              .personalizationDTO
                                                                              .termsAndConditions,
                                                                            _vm
                                                                              .agb[
                                                                              "" +
                                                                                client.id
                                                                            ].id
                                                                          ) > -1
                                                                        : _vm
                                                                            .personalizationDTO
                                                                            .termsAndConditions,
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        var $$a =
                                                                            _vm
                                                                              .personalizationDTO
                                                                              .termsAndConditions,
                                                                          $$el =
                                                                            $event.target,
                                                                          $$c =
                                                                            $$el.checked
                                                                              ? true
                                                                              : false
                                                                        if (
                                                                          Array.isArray(
                                                                            $$a
                                                                          )
                                                                        ) {
                                                                          var $$v =
                                                                              _vm
                                                                                .agb[
                                                                                "" +
                                                                                  client.id
                                                                              ]
                                                                                .id,
                                                                            $$i =
                                                                              _vm._i(
                                                                                $$a,
                                                                                $$v
                                                                              )
                                                                          if (
                                                                            $$el.checked
                                                                          ) {
                                                                            $$i <
                                                                              0 &&
                                                                              _vm.$set(
                                                                                _vm.personalizationDTO,
                                                                                "termsAndConditions",
                                                                                $$a.concat(
                                                                                  [
                                                                                    $$v,
                                                                                  ]
                                                                                )
                                                                              )
                                                                          } else {
                                                                            $$i >
                                                                              -1 &&
                                                                              _vm.$set(
                                                                                _vm.personalizationDTO,
                                                                                "termsAndConditions",
                                                                                $$a
                                                                                  .slice(
                                                                                    0,
                                                                                    $$i
                                                                                  )
                                                                                  .concat(
                                                                                    $$a.slice(
                                                                                      $$i +
                                                                                        1
                                                                                    )
                                                                                  )
                                                                              )
                                                                          }
                                                                        } else {
                                                                          _vm.$set(
                                                                            _vm.personalizationDTO,
                                                                            "termsAndConditions",
                                                                            $$c
                                                                          )
                                                                        }
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "checkbox-label icon icon-check",
                                                                }),
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "privacy.agb.iAccept"
                                                                      )
                                                                    ) +
                                                                    "\n                            "
                                                                ),
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "inline-link",
                                                                    attrs: {
                                                                      href: "#",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          $event.stopPropagation()
                                                                          $event.preventDefault()
                                                                          return _vm.openAGBModal(
                                                                            client
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                              " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "privacy.agb.agbOf"
                                                                          )
                                                                        )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "global.forms.required"
                                                                      )
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    : [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form__group form__group--checkbox",
                                                            class: {
                                                              "form__field--error":
                                                                _vm.showErrors &&
                                                                !_vm
                                                                  .personalizationDTO
                                                                  .fallbackAgbChecked,
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "label",
                                                              {
                                                                staticClass:
                                                                  "form__label",
                                                                attrs: {
                                                                  for: "agb-fallback",
                                                                },
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name: "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .personalizationDTO
                                                                          .fallbackAgbChecked,
                                                                      expression:
                                                                        "personalizationDTO.fallbackAgbChecked",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    id: "agb-fallback",
                                                                    name: "agb",
                                                                    required:
                                                                      "",
                                                                    type: "checkbox",
                                                                  },
                                                                  domProps: {
                                                                    checked:
                                                                      Array.isArray(
                                                                        _vm
                                                                          .personalizationDTO
                                                                          .fallbackAgbChecked
                                                                      )
                                                                        ? _vm._i(
                                                                            _vm
                                                                              .personalizationDTO
                                                                              .fallbackAgbChecked,
                                                                            null
                                                                          ) > -1
                                                                        : _vm
                                                                            .personalizationDTO
                                                                            .fallbackAgbChecked,
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        var $$a =
                                                                            _vm
                                                                              .personalizationDTO
                                                                              .fallbackAgbChecked,
                                                                          $$el =
                                                                            $event.target,
                                                                          $$c =
                                                                            $$el.checked
                                                                              ? true
                                                                              : false
                                                                        if (
                                                                          Array.isArray(
                                                                            $$a
                                                                          )
                                                                        ) {
                                                                          var $$v =
                                                                              null,
                                                                            $$i =
                                                                              _vm._i(
                                                                                $$a,
                                                                                $$v
                                                                              )
                                                                          if (
                                                                            $$el.checked
                                                                          ) {
                                                                            $$i <
                                                                              0 &&
                                                                              _vm.$set(
                                                                                _vm.personalizationDTO,
                                                                                "fallbackAgbChecked",
                                                                                $$a.concat(
                                                                                  [
                                                                                    $$v,
                                                                                  ]
                                                                                )
                                                                              )
                                                                          } else {
                                                                            $$i >
                                                                              -1 &&
                                                                              _vm.$set(
                                                                                _vm.personalizationDTO,
                                                                                "fallbackAgbChecked",
                                                                                $$a
                                                                                  .slice(
                                                                                    0,
                                                                                    $$i
                                                                                  )
                                                                                  .concat(
                                                                                    $$a.slice(
                                                                                      $$i +
                                                                                        1
                                                                                    )
                                                                                  )
                                                                              )
                                                                          }
                                                                        } else {
                                                                          _vm.$set(
                                                                            _vm.personalizationDTO,
                                                                            "fallbackAgbChecked",
                                                                            $$c
                                                                          )
                                                                        }
                                                                      },
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "checkbox-label icon icon-check",
                                                                }),
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "privacy.agb.iAccept"
                                                                      )
                                                                    ) +
                                                                    "\n                            "
                                                                ),
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    attrs: {
                                                                      target:
                                                                        "_blank",
                                                                      href: "https://www.messe-stuttgart.de/agb/",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "privacy.agb.agbOf"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "global.forms.required"
                                                                      )
                                                                    ) +
                                                                    "\n                          "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                  _vm._v(" "),
                                                  idx <
                                                  _vm.clientsWithConsent
                                                    .length -
                                                    1
                                                    ? [_vm._m(4, true)]
                                                    : _vm._e(),
                                                ],
                                                2
                                              ),
                                            ]
                                          }
                                        ),
                                      ]
                                    : [
                                        _vm.fallbackAdditionalNoticeHtml
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "checkout__additional-notices-container",
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass:
                                                      "additional-notice",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.fallbackAdditionalNoticeHtml
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form__group form__group--checkbox",
                                            class: {
                                              "form__field--error":
                                                _vm.showErrors &&
                                                !_vm.personalizationDTO
                                                  .fallbackPrivacyChecked,
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass: "form__label",
                                                attrs: {
                                                  for: "privacy-fallback",
                                                },
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.personalizationDTO
                                                          .fallbackPrivacyChecked,
                                                      expression:
                                                        "personalizationDTO.fallbackPrivacyChecked",
                                                    },
                                                  ],
                                                  attrs: {
                                                    id: "privacy-fallback",
                                                    name: "privacy",
                                                    required: "",
                                                    type: "checkbox",
                                                  },
                                                  domProps: {
                                                    checked: Array.isArray(
                                                      _vm.personalizationDTO
                                                        .fallbackPrivacyChecked
                                                    )
                                                      ? _vm._i(
                                                          _vm.personalizationDTO
                                                            .fallbackPrivacyChecked,
                                                          null
                                                        ) > -1
                                                      : _vm.personalizationDTO
                                                          .fallbackPrivacyChecked,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      var $$a =
                                                          _vm.personalizationDTO
                                                            .fallbackPrivacyChecked,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            _vm.$set(
                                                              _vm.personalizationDTO,
                                                              "fallbackPrivacyChecked",
                                                              $$a.concat([$$v])
                                                            )
                                                        } else {
                                                          $$i > -1 &&
                                                            _vm.$set(
                                                              _vm.personalizationDTO,
                                                              "fallbackPrivacyChecked",
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                )
                                                            )
                                                        }
                                                      } else {
                                                        _vm.$set(
                                                          _vm.personalizationDTO,
                                                          "fallbackPrivacyChecked",
                                                          $$c
                                                        )
                                                      }
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass:
                                                    "checkbox-label icon icon-check",
                                                }),
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "privacy.client.privacyStatement1"
                                                      )
                                                    ) +
                                                    "\n                      "
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "inline-link",
                                                    attrs: {
                                                      target: "_blank",
                                                      href: "https://www.messe-stuttgart.de/datenschutzerklaerung/",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "privacy.client.privacyStatement2"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "privacy.client.privacyStatement3"
                                                      )
                                                    ) +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "global.forms.required"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "form__group form__group--checkbox",
                                            class: {
                                              "form__field--error":
                                                _vm.showErrors &&
                                                !_vm.personalizationDTO
                                                  .fallbackAgbChecked,
                                            },
                                          },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass: "form__label",
                                                attrs: { for: "agb-fallback" },
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.personalizationDTO
                                                          .fallbackAgbChecked,
                                                      expression:
                                                        "personalizationDTO.fallbackAgbChecked",
                                                    },
                                                  ],
                                                  attrs: {
                                                    id: "agb-fallback",
                                                    name: "agb",
                                                    required: "",
                                                    type: "checkbox",
                                                  },
                                                  domProps: {
                                                    checked: Array.isArray(
                                                      _vm.personalizationDTO
                                                        .fallbackAgbChecked
                                                    )
                                                      ? _vm._i(
                                                          _vm.personalizationDTO
                                                            .fallbackAgbChecked,
                                                          null
                                                        ) > -1
                                                      : _vm.personalizationDTO
                                                          .fallbackAgbChecked,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      var $$a =
                                                          _vm.personalizationDTO
                                                            .fallbackAgbChecked,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            _vm.$set(
                                                              _vm.personalizationDTO,
                                                              "fallbackAgbChecked",
                                                              $$a.concat([$$v])
                                                            )
                                                        } else {
                                                          $$i > -1 &&
                                                            _vm.$set(
                                                              _vm.personalizationDTO,
                                                              "fallbackAgbChecked",
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                )
                                                            )
                                                        }
                                                      } else {
                                                        _vm.$set(
                                                          _vm.personalizationDTO,
                                                          "fallbackAgbChecked",
                                                          $$c
                                                        )
                                                      }
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass:
                                                    "checkbox-label icon icon-check",
                                                }),
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "privacy.agb.iAccept"
                                                      )
                                                    ) +
                                                    "\n                      "
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      target: "_blank",
                                                      href: "https://www.messe-stuttgart.de/agb/",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "privacy.agb.agbOf"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "global.forms.required"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                  _vm._v(" "),
                                  _c(
                                    "Modal",
                                    { ref: "privacyModal" },
                                    [
                                      _c(
                                        "template",
                                        { slot: "content" },
                                        [
                                          _vm.selectedPrivacyStatement
                                            ? [
                                                _c("div", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm
                                                        .selectedPrivacyStatement
                                                        .html
                                                    ),
                                                  },
                                                }),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "Modal",
                                    { ref: "agbModal" },
                                    [
                                      _c(
                                        "template",
                                        { slot: "content" },
                                        [
                                          _vm.selectedAGB
                                            ? [
                                                _c("div", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.selectedAGB.html
                                                    ),
                                                  },
                                                }),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.showErrors &&
                                        !_vm.checkoutFormIsValid,
                                      expression:
                                        "showErrors && !checkoutFormIsValid",
                                    },
                                  ],
                                  staticClass: "checkout-form__error",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "global.errorMessages.unfinishedForm"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "checkout-form__group" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "button",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          $event.preventDefault()
                                          return _vm.cancelRegistration.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t("global.links.cancel")
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "button process-button",
                                      class: {
                                        "button--disabled":
                                          !_vm.checkoutFormIsValid,
                                      },
                                      attrs: {
                                        type: "submit",
                                        disabled: !_vm.checkoutFormIsValid,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t("global.links.requestTicket")
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            2
                          ),
                        ]),
                      ]),
                    ],
                    2
                  ),
                ]
              : [
                  _c("div", { staticClass: "alert alert-error" }, [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("global.errorMessages.dataNotLoadedCorrectly")
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.cancelRegistration.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("global.links.toTicketShop")) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "checkout-form__group" }, [_c("hr")])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "checkout-form__group", staticStyle: { clear: "both" } },
      [_c("hr")]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "checkout-form__group", staticStyle: { clear: "both" } },
      [_c("hr")]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "checkout-form__group", staticStyle: { clear: "both" } },
      [_c("hr")]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "checkout-form__group" }, [_c("hr")])
  },
]
render._withStripped = true

export { render, staticRenderFns }